import { DocumentData, FirestoreDataConverter, QueryDocumentSnapshot, SnapshotOptions, WithFieldValue } from "firebase/firestore";
import { Article } from "../types/Article";
import { FirebaseArticle } from "../types/firebase/FirebaseArticle";
import { DateTime } from "luxon";
import * as firestore from "firebase/firestore";

export const articleConverter: FirestoreDataConverter<Article> = {
    toFirestore: function (article: Article): DocumentData {
        let data: FirebaseArticle = {
            id: article.id,
            title: article.title,
            content: article.content,
            url: article.url,
            imageUrl: article.imageUrl,
            deepLink: article.deepLink,
            isFeatured: article.featured.isFeatured,
            isFeaturedOrder: article.featured.isFeaturedOrder,
            isPublished: article.published.isPublished,
            publishedTime: article.published.publishedTime.toMillis(),
            lastUpdate: firestore.serverTimestamp()
        }
        return data;
    },
    fromFirestore: function (snapshot: QueryDocumentSnapshot<DocumentData>, options?: SnapshotOptions): Article {
        const data = snapshot.data(options) as FirebaseArticle;
        return {
            id: data.id,
            title: data.title,
            content: data.content,
            url: data.url,
            imageUrl: data.imageUrl,
            deepLink: data.deepLink,
            featured: {
                isFeatured: data.isFeatured,
                isFeaturedOrder: data.isFeaturedOrder
            },
            published: {
                isPublished: data.isPublished === undefined ? false : data.isPublished,
                publishedTime: DateTime.fromMillis(data.publishedTime),
            },
            lastUpdate: data.lastUpdate
                ? DateTime.fromMillis((data.lastUpdate as firestore.Timestamp).toMillis())
                : DateTime.now()
        };
    }
}